export default class LatLng extends google.maps.LatLng {
    constructor(...args){
        super(...args)
        this._data = null
    }
    /**
     * Get latLng additional data
     */
    getData(){
        return this._data
    }
    /**
     * Set additional data
     * @param {*} data 
     */
    setData(data){
        this._data = JSON.parse(JSON.stringify(data))
    }
}